import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { Profile } from 'src/app/shared/model/profile.model';
import { ProfileService } from 'src/app/shared/service/profile.service';

@Component({
  selector: 'app-profile-form',
  templateUrl: './profile-form.component.html',
  styleUrls: ['./profile-form.component.scss']
})
export class ProfileFormComponent implements OnInit {
  profile: Profile = new Profile();
  profileForm: FormGroup;
  date: Date;

  constructor(
    private spinner: Spinner,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private toastService: ToastrService,
    private service: ProfileService
  ) { }

  ngOnInit(): void {
    this.service.getProfileUser().subscribe((res: any) => {
      this.profile = new Profile(res.data);
      this.initForm();
    });
    this.initForm();
    this.date = new Date();
  }

  initForm(): void {
    this.profileForm = this.fb.group({
      firstName: [{ value: this.profile.firstName, disabled: true }],
      lastName: [{ value: this.profile.lastName, disabled: true }],
      companyName: [{ value: this.profile.companyName, disabled: true }],
      companyEmail: [{ value: this.profile.companyEmail, disabled: true }],
      userName: [{ value: this.profile.userName, disabled: true }],
      supplierID: [this.profile.supplierID, [Validators.required]],
    });
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  submitProfileForm(): void {
    if (!this.profileForm.valid) {
      this.markFormGroupTouched(this.profileForm);
      return;
    } else {
      this.openDialog();
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      minWidth: '300px',
      data: {
        message: MESSAGE_TOAST.CONFIRM_SUBMIT_SUPPLIER_ID,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const body = new Profile(this.profileForm.getRawValue(), false).convertToReqBody();
        this.spinner.show();
        this.service.requestProfileUserAccess(body).subscribe((res: any) => {
          this.spinner.hide();
          this.profile = new Profile(res.data);
          this.toastService.success(MESSAGE_TOAST.SUBMIT_SUPPLIER_ID_SUCCESS);
          this.initForm();
        });
      }
    });
  }
}
